<p-dialog
	styleClass="w-[95%] max-w-[22rem] role-selection-dialog"
	header="Please Select Your Role"
	[visible]="visible()"
	[modal]="true"
	[closable]="false"
	[draggable]="false"
	[resizable]="false"
	(visibleChange)="visibleChange.emit($event)"
>
	<p-panel class="mt-2.5!" [showHeader]="false">
		<div class="mt-4! space-y-1.5">
			@for (role of userRoles(); track role) {
				<div class="flex items-center gap-2.5 rounded px-1 transition-colors hover:bg-gray-50">
					<p-radiobutton
						name="selectedRole"
						class="mb-[7px]"
						[value]="role"
						[ngModel]="selectedRole()"
						[inputId]="'role-' + role"
						(ngModelChange)="onRoleChange($event)"
					/>
					<div class="flex flex-1 flex-col">
						<label
							class="cursor-pointer text-base leading-0 font-medium"
							[for]="'role-' + role"
							[style.color]="getRoleColor(role)"
						>
							{{ ROLE_OPTIONS[role].label || role }}
						</label>
					</div>
				</div>
			}
		</div>
		<div class="mt-3 flex items-center gap-3 rounded border border-gray-200 bg-gray-50 p-3">
			<p-checkbox
				inputId="rememberChoice"
				[ngModel]="rememberChoice()"
				[binary]="true"
				(ngModelChange)="onRememberChoiceChange($event)"
			/>
			<div class="flex-1">
				<label for="rememberChoice" class="cursor-pointer text-sm font-medium text-gray-700"> Remember my choice </label>
				<div class="mt-0 text-xs text-gray-500">Don't show this dialog again</div>
			</div>
		</div>
	</p-panel>

	<ng-template #footer>
		<div class="flex gap-3">
			<p-button
				label="Confirm"
				icon="pi pi-check"
				styleClass="w-64!"
				severity="success"
				[pAutoFocus]="true"
				[disabled]="!selectedRole()"
				(click)="onConfirm()"
			/>
		</div>
	</ng-template>
</p-dialog>
